export default __webpack_public_path__ + "static/media/contact.48e62fc6.gif";